var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdgeTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9809 11.4808C9.69705 11.4808 9.46167 11.7162 9.46167 12.0001V14.7693C9.46167 15.0531 9.69705 15.2885 9.9809 15.2885C10.2647 15.2885 10.5001 15.0531 10.5001 14.7693V12.0001C10.5001 11.7162 10.2647 11.4808 9.9809 11.4808Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 10.7885C11.7737 10.7885 11.5383 11.0238 11.5383 11.3077V15.4615C11.5383 15.7454 11.7737 15.9808 12.0576 15.9808C12.3414 15.9808 12.5768 15.7454 12.5768 15.4615V11.3077C12.5768 11.0238 12.3414 10.7885 12.0576 10.7885Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1345 11.4808C13.8506 11.4808 13.6152 11.7162 13.6152 12.0001V14.7693C13.6152 15.0531 13.8506 15.2885 14.1345 15.2885C14.4183 15.2885 14.6537 15.0531 14.6537 14.7693V12.0001C14.6537 11.7162 14.4183 11.4808 14.1345 11.4808Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5962 8.01923H16.9038H15.8377L14.9792 6.30231C14.6608 5.65154 14.0031 5.25 13.2762 5.25H10.8392C10.1123 5.25 9.46154 5.65154 9.13615 6.30231L8.27769 8.01923H7.19077H6.51923C6.23538 8.01923 6 8.25462 6 8.53846C6 8.82231 6.23538 9.05769 6.51923 9.05769H6.70615L7.29462 16.9846C7.37077 17.9746 8.20154 18.75 9.19154 18.75H14.9238C15.9208 18.75 16.7515 17.9746 16.8208 16.9846L17.3885 9.05769H17.5962C17.88 9.05769 18.1154 8.82231 18.1154 8.53846C18.1154 8.25462 17.88 8.01923 17.5962 8.01923ZM10.0638 6.76615C10.2092 6.46846 10.5069 6.28846 10.8392 6.28846H13.2831C13.6154 6.28846 13.9131 6.46846 14.0585 6.76615L14.6815 8.01923H9.43385L10.0638 6.76615ZM15.7823 16.9085C15.7546 17.3585 15.3738 17.7115 14.9238 17.7115H9.19154C8.74154 17.7115 8.36077 17.3585 8.32615 16.9085L7.74462 9.05769H8.59615H15.5192H16.3431L15.7823 16.9085Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeTrashIcon);
export default __webpack_public_path__ + "static/media/edge-trash-icon.819c406d795a0b21a9373a95e00139ce.svg";
export { ForwardRef as ReactComponent };